import { Layers } from '../index';

// Structural interfaces to match Superwall types without importing them
interface MinimalPaywallInfo {
  identifier: string;
  name?: string;
  url?: string;
  products?: { id: string }[];
  experiment?: {
    id: string;
    variantId: string;
  };
}

export const Superwall = {
  /**
   * Track that a paywall was presented to the user.
   * Call this within your Superwall presentation handler.
   *
   * @param paywallInfo - The info object provided by Superwall callbacks
   */
  trackPresentation: async (paywallInfo: MinimalPaywallInfo) => {
    try {
      if (!paywallInfo) return;

      await Layers.track('paywall_show', {
        paywall_id: paywallInfo.identifier,
        placement: paywallInfo.name || 'unknown',
        ab_test: paywallInfo.experiment
          ? {
              id: paywallInfo.experiment.id,
              variant: paywallInfo.experiment.variantId
            }
          : undefined,
        url: paywallInfo.url
      });
    } catch (e) {
      // safe fail
    }
  },

  /**
   * Track that a paywall was dismissed.
   *
   * @param paywallInfo - The info object provided by Superwall callbacks
   */
  trackDismiss: async (paywallInfo: MinimalPaywallInfo) => {
    try {
      if (!paywallInfo) return;

      await Layers.track('paywall_dismiss', {
        paywall_id: paywallInfo.identifier,
        reason: 'user_close' // Default assumption; Superwall might provide specific reasons in future
      });
    } catch (e) {
      // safe fail
    }
  }
};
